import { apiRequest } from "./httpClient";

// senderId/receiverId are usernames - the chat endpoints treat them as plain
// string identifiers, so they line up with what the rest of the app (auth,
// friends, search) already uses everywhere.
export async function sendMessage(username, token, receiverId, msg) {
    return apiRequest("api/chat/send-message", {
        token,
        body: { username, senderId: username, receiverId, msg },
    });
}

export async function showConversation(username, token, receiverId, timestamp) {
    return apiRequest("api/chat/show-conversation", {
        token,
        body: { username, senderId: username, receiverId, timestamp },
    });
}

export async function showLastMessages(username, token) {
    return apiRequest("api/chat/show-last-messages", {
        token,
        body: { username, senderId: username },
    });
}
